import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import { Global_Data } from "../../globalData/GlobalData";
import CloseIcon from "@mui/icons-material/Close";

function NestedDialog({ data, open, renderComponent, handleClose }) {
  const [oldComponetData, setOldComponentData] = useState({});
  const [oldModalEditData, setOldModalEditData] = useState({});
  const [oldComponetChildData, setOldComponentChildData] = useState([]);
  const { setOpenModalChildData, setopenModalDataActive, setModalEditData, setIsOpenModalChildData } = Global_Data();

  useEffect(() => {
    if (open) {
      setopenModalDataActive((predata) => {
        setOldComponentData(predata);
        return data.component;
      });
      setModalEditData((predata) => {
        setOldModalEditData(predata);
        return {};
      });
      setOpenModalChildData((predata) => {
        setOldComponentChildData(predata);
        return data?.child;
      });
      setIsOpenModalChildData(true);
    } else {
      setModalEditData(oldModalEditData);
      setOpenModalChildData(oldComponetChildData);
      setopenModalDataActive(oldComponetData);
      setIsOpenModalChildData(false);
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={() => handleClose(false)}
      aria-labelledby="nested-dialog-title"
      {...data?.component?.sProps}
    >
      <IconButton
        onClick={() => handleClose(false)}
        sx={{ position: "absolute", top: 8, right: 8 }}
      >
        <CloseIcon />
      </IconButton>
      <DialogTitle id="nested-dialog-title">
        {data?.component?.sLabel}
      </DialogTitle>
      <DialogContent>
        {renderComponent(data?.child, data)}
      </DialogContent>
    </Dialog>
  );
}

export default memo(NestedDialog);
